import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { ProfileTypes } from '@sda/enums';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { UsersState } from '@sda/interfaces/reducer/users.reducer';
import type { User } from '@sda/interfaces/user';
import type { FetchDataType } from '@sda/sdk/interfaces';

// LISTENERS

export const startToggleAdmin = createAction<string>(`${Reducers.USERS}/startToggleAdmin`);
export const startLogoutUser = createAction<string>(`${Reducers.USERS}/startLogoutUser`);
export const startForceChangeEmail = createAction<{ email: string, userId: string }>(`${Reducers.USERS}/startForceChangeEmail`);
export const startDeleteUser = createAction<string>(`${Reducers.USERS}/startDeleteUser`);
export const startMergeUsers = createAction<{ sourceUserId: string, targetUserId: string }>(`${Reducers.USERS}/startMergeUsers`);
export const startChangeProfileOwner = createAction<{ userId: string, profileId: string, profileType: ProfileTypes }>(`${Reducers.USERS}/startChangeProfileOwner`);
export const startDeleteProfile = createAction<{ profileId: string, profileType: ProfileTypes }>(`${Reducers.USERS}/startDeleteProfile`);
export const startFetchPublicUser = createAction<string>(`${Reducers.USERS}/startFetchPublicUser`);
export const startFetchUserDetails = createAction<string>(`${Reducers.USERS}/startFetchUserDetails`); // Admin

export const userAdapter = createEntityAdapter<User & FetchDataType>();

const initialState: UsersState = {
  current: null,
};

const usersSlice = createSlice({
  initialState: userAdapter.getInitialState<UsersState>(initialState),
  name: Reducers.USERS,
  reducers: {
    ...extractSharedActions(userAdapter),
    setCurrentUser: (state, action: PayloadAction<string>) => {
      state.current = action.payload;
    },
  },
});

export const {
  addOne: addUser, updateOne: updateUser, upsertOne: upsertUser,
  setCurrentUser,
} = usersSlice.actions;

export default usersSlice.reducer;
